import { useCallback, useEffect, useMemo, useState } from 'react';

export const useCarousel = ({
  imageCount,
  initialIndex,
}: {
  imageCount: number;
  initialIndex?: number;
}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(initialIndex ?? 0);

  useEffect(() => {
    setCurrentImageIndex(initialIndex ?? 0);
  }, [initialIndex]);

  const showLeftButton = useMemo(() => {
    return imageCount > 1 && currentImageIndex > 0;
  }, [currentImageIndex, imageCount]);

  const showRightButton = useMemo(() => {
    return imageCount > 1 && currentImageIndex < imageCount - 1;
  }, [currentImageIndex, imageCount]);

  const onLeftButtonClick = useCallback(() => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  }, [currentImageIndex]);

  const onRightButtonClick = useCallback(() => {
    if (currentImageIndex < imageCount - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  }, [currentImageIndex, imageCount]);

  return {
    currentImageIndex,
    onLeftButtonClick,
    onRightButtonClick,
    showLeftButton,
    showRightButton,
  };
};
